{
  "familyId": "MET-COORDINATEN",
  "questions": [
    {
      "id": "MET-COORDINATEN-001",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Welk punt heeft de coördinaten (3, 5)?",
      "context": "In een assenstelsel staan vier punten: A = (3, 5), B = (5, 3), C = (3, 3), D = (5, 5).",
      "options": ["Punt A", "Punt B", "Punt C", "Punt D"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 7,
            "height": 7,
            "showGrid": true,
            "points": [
              { "x": 3, "y": 5, "label": "A" },
              { "x": 5, "y": 3, "label": "B" },
              { "x": 3, "y": 3, "label": "C" },
              { "x": 5, "y": 5, "label": "D" }
            ],
            "label": "Assenstelsel met punten A, B, C, D"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Coördinaten lezen",
            "content": "Bij coördinaten (x, y) ga je eerst naar rechts (x-as) en dan omhoog (y-as). (3, 5) = 3 naar rechts, 5 omhoog = punt A.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "coordinates_identify_point",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: bij coördinaten (x, y) ga je eerst langs de x-as (horizontaal) en dan langs de y-as (verticaal). Stap 1: x = 3 → ga 3 naar rechts. Stap 2: y = 5 → ga 5 omhoog. Stap 3: Dat is punt A.",
        "distractorExplanations": {
          "0": "Correct! (3, 5) = 3 naar rechts, 5 omhoog = punt A.",
          "1": "Punt B = (5, 3). Je hebt x en y omgewisseld. Bij (3, 5) ga je eerst 3 naar rechts, dan 5 omhoog.",
          "2": "Punt C = (3, 3). De x-coördinaat klopt (3), maar de y-coördinaat is 5, niet 3.",
          "3": "Punt D = (5, 5). De y-coördinaat klopt (5), maar de x-coördinaat is 3, niet 5."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-002",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Punt P staat op (4, 2) in het assenstelsel. Punt Q staat 3 hokjes naar rechts en 1 hokje omhoog. Wat zijn de coördinaten van Q?",
      "context": null,
      "options": ["(7, 3)", "(1, 1)", "(4, 5)", "(7, 2)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 9,
            "height": 6,
            "showGrid": true,
            "points": [
              { "x": 4, "y": 2, "label": "P" }
            ],
            "label": "Assenstelsel met punt P"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Coördinaten verschuiven",
            "content": "Naar rechts = x wordt groter. Omhoog = y wordt groter. P = (4, 2). 3 naar rechts: x = 4 + 3 = 7. 1 omhoog: y = 2 + 1 = 3. Q = (7, 3).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "coordinates_translate",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: tel de verschuiving op bij de coördinaten. Stap 1: P = (4, 2). Stap 2: 3 naar rechts → x = 4 + 3 = 7. Stap 3: 1 omhoog → y = 2 + 1 = 3. Stap 4: Q = (7, 3).",
        "distractorExplanations": {
          "0": "Correct! (4+3, 2+1) = (7, 3).",
          "1": "(1, 1) — je hebt afgetrokken in plaats van opgeteld. Naar rechts = x groter, omhoog = y groter.",
          "2": "(4, 5) — je hebt alleen de y-coördinaat veranderd (+3), maar de x moet ook veranderen (+3 naar rechts).",
          "3": "(7, 2) — je bent vergeten 1 omhoog te gaan. y = 2 + 1 = 3, niet 2."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-003",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Welke coördinaten horen bij de oorsprong van het assenstelsel?",
      "context": null,
      "options": ["(0, 0)", "(1, 1)", "(0, 1)", "(1, 0)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 5,
            "height": 5,
            "showGrid": true,
            "points": [
              { "x": 0, "y": 0, "label": "O" }
            ],
            "label": "Assenstelsel met oorsprong O"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Oorsprong",
            "content": "De oorsprong is het punt waar de x-as en y-as elkaar kruisen. Dat is altijd (0, 0) — nul naar rechts, nul omhoog.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "coordinates_origin",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "De oorsprong is het snijpunt van de x-as en y-as. Beide assen beginnen bij 0, dus de oorsprong = (0, 0).",
        "distractorExplanations": {
          "0": "Correct! De oorsprong = (0, 0).",
          "1": "(1, 1) is het eerste punt rechts en boven de oorsprong, niet de oorsprong zelf.",
          "2": "(0, 1) is 1 omhoog op de y-as, niet de oorsprong.",
          "3": "(1, 0) is 1 naar rechts op de x-as, niet de oorsprong."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-004",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Drie hoekpunten van een rechthoek zijn: (1, 1), (1, 4), (6, 1). Wat is het vierde hoekpunt?",
      "context": null,
      "options": ["(6, 4)", "(4, 6)", "(6, 6)", "(4, 4)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 8,
            "height": 6,
            "showGrid": true,
            "points": [
              { "x": 1, "y": 1, "label": "A" },
              { "x": 1, "y": 4, "label": "B" },
              { "x": 6, "y": 1, "label": "C" },
              { "x": 6, "y": 4, "label": "?" }
            ],
            "label": "Rechthoek met 3 hoekpunten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Vierde hoekpunt vinden",
            "content": "Een rechthoek heeft tegenoverliggende zijden die gelijk zijn. Het vierde punt moet dezelfde x als C (6) en dezelfde y als B (4) hebben: (6, 4).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "coordinates_rectangle_vertex",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: het vierde hoekpunt deelt coördinaten met twee andere punten. Stap 1: Punt C heeft x = 6, punt B heeft y = 4. Stap 2: Het vierde punt = (6, 4). Controleer: A(1,1), B(1,4), C(6,1), D(6,4) vormen een rechthoek ✓.",
        "distractorExplanations": {
          "0": "Correct! Het vierde hoekpunt is (6, 4).",
          "1": "(4, 6) — je hebt x en y omgewisseld. Het moet (6, 4) zijn.",
          "2": "(6, 6) — de y-coördinaat moet 4 zijn (gelijk aan punt B), niet 6.",
          "3": "(4, 4) — de x-coördinaat moet 6 zijn (gelijk aan punt C), niet 4."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-005",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Wat is de afstand tussen punt A (2, 3) en punt B (2, 8)?",
      "context": null,
      "options": ["5", "6", "10", "3"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 6,
            "height": 10,
            "showGrid": true,
            "points": [
              { "x": 2, "y": 3, "label": "A" },
              { "x": 2, "y": 8, "label": "B" }
            ],
            "label": "Punten A en B op dezelfde verticale lijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Afstand op één as",
            "content": "Als twee punten dezelfde x-coördinaat hebben, is de afstand het verschil van de y-coördinaten: |8 − 3| = 5.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "coordinates_distance_vertical",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: als punten op dezelfde verticale lijn staan (zelfde x), is de afstand = verschil in y. Stap 1: A = (2, 3), B = (2, 8). Stap 2: Zelfde x (2), dus afstand = |8 − 3| = 5.",
        "distractorExplanations": {
          "0": "Correct! |8 − 3| = 5 eenheden.",
          "1": "6 klopt niet. Het verschil is 8 − 3 = 5, niet 6.",
          "2": "10 klopt niet. Je hebt misschien 3 + 8 = 11 of iets anders berekend. Afstand = |8 − 3| = 5.",
          "3": "3 is de y-coördinaat van punt A, niet de afstand. Afstand = |8 − 3| = 5."
        }
      }
    }
  ]
}